export const environment = {
  "production": false,
  "appName": "@ec/fleet-dashboard-v2",
  "appVersion": "1.0.27",
  "apiUrl": "https://public.stage.stagetest.elevationcurb.com/api/v1",
  "webAppUrl": "https://webapp.stage.stagetest.elevationcurb.com",
  "hubAppUrl": "https://hub.stage.stagetest.elevationcurb.com",
  "installationApiUrl": "https://install.stage.stagetest.elevationcurb.com/api",
  "liveDataServiceUrl": "wss://lds.stage.stagetest.elevationcurb.com",
  "timezoneApiKey": "AIzaSyD3NiA0YUwPfnOPGP5fyWkWdNtO5LIlQlU",
  "auth0": {
    "domain": "stage-curbenergy.us.auth0.com",
    "clientId": "8lBiIGem5vv2LBcfFxzUwkOYETtvnprT",
    "redirectUri": window.location.origin,
    "audience": "public.energycurb.com",
    "responseType": "token id_token",
    "scope": "openid profile email",
    "connection": "users"
  }
};
